import * as React from 'react';
import { Link } from 'react-router-dom';
import { SVG } from '../../../../Utils/SVG';
const closeIconURL = require('../../../../../icons/cross.svg');
import './style.css';

export interface SignUpToFavouritePromptProps {
  onClose: () => void;
}

export interface SignUpToFavouritePromptState {
  /* empty*/
}

export class SignUpToFavouritePrompt extends React.Component<
  SignUpToFavouritePromptProps,
  SignUpToFavouritePromptState
> {
  render() {
    const { onClose } = this.props;

    return (
      <div className="sign-up-to-favourite-prompt">
        <button
          className="sign-up-to-favourite-prompt-close-button"
          onClick={onClose}
        >
          <SVG
            className="sign-up-to-favourite-prompt-close-icon"
            src={closeIconURL}
          />
        </button>
        <section className="sign-up-to-favourite-prompt-content">
          <p className="sign-up-to-favourite-prompt-message">
            You need to be signed in to favourite this video!
          </p>
          <p className="sign-up-to-favourite-prompt-actions">
            Please{' '}
            <Link
              className="edge-of-play-link sign-up-to-favourite-prompt-link"
              to="/sign-up"
            >
              sign up
            </Link>{' '}
            or{' '}
            <Link
              className="edge-of-play-link sign-up-to-favourite-prompt-link"
              to="/login"
            >
              log in
            </Link>.
          </p>
        </section>
      </div>
    );
  }
}

export default SignUpToFavouritePrompt;



// WEBPACK FOOTER //
// ./src/app/components/Video/VideoDetailsBar/VideoActions/SignUpToFavouritePrompt/index.tsx